// Mini prévia de um tema (Aparência > Tema, 0.67): fundo, cartão com botão e a barra de abas, no modo atual.
import { Text, View } from 'react-native';
import { previaTema, type Tema } from './theme';

/** Listras de uma bandeira lado a lado (só decoração, nunca atrás de texto). */
export function Listras({ cores, altura, vertical }: { cores: string[]; altura?: number; vertical?: boolean }) {
  return (
    <View style={{ flexDirection: vertical ? 'column' : 'row', height: altura, alignSelf: 'stretch', overflow: 'hidden' }}>
      {cores.map((c, i) => <View key={i} style={{ flex: 1, backgroundColor: c }} />)}
    </View>
  );
}

export function TemaPrevia({ tema }: { tema: Tema | undefined }) {
  const p = previaTema(tema);
  const abas = p.cores.slice(0, 5);
  return (
    <View style={{ height: 78, borderRadius: 10, overflow: 'hidden', backgroundColor: p.bg, borderWidth: 1, borderColor: p.line }}>
      <View style={{ flex: 1, padding: 6, gap: 4 }}>
        <View style={{ backgroundColor: p.card, borderRadius: 6, padding: 5, gap: 4 }}>
          <View style={{ height: 4, width: '70%', borderRadius: 2, backgroundColor: p.text, opacity: 0.85 }} />
          <View style={{ height: 3, width: '45%', borderRadius: 2, backgroundColor: p.sub }} />
          <View style={{ alignSelf: 'flex-start', backgroundColor: p.destaque, borderRadius: 6, paddingHorizontal: 6, paddingVertical: 1 }}>
            <Text style={{ color: '#fff', fontSize: 7, fontWeight: '800' }}>Aa</Text>
          </View>
        </View>
      </View>
      {!!tema?.listras && <Listras cores={tema.listras} altura={2} />}
      <View style={{ height: 16, backgroundColor: p.card, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', paddingHorizontal: 6,
        borderTopWidth: tema?.listras ? 0 : 1, borderTopColor: p.line }}>
        {abas.map((c, i) => <View key={i} style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: c }} />)}
        <View style={{ width: 10, height: 10, borderRadius: 5, backgroundColor: p.destaque }} />
      </View>
    </View>
  );
}
